import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import { FormattedMessage, useIntl } from "react-intl";

const DiscardChangesModal = ({ open, onClose, onValidate }) => {
  const intl = useIntl();

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="validation-modal-style">
        <div className="header">
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <div className="title">
            {intl
              .formatMessage({
                id: "attention",
                defaultMessage: "Attention!",
              })
              .toUpperCase()}
          </div>
          <div className="content">
            <FormattedMessage
              id="modal_discard_message"
              defaultMessage="Les modifications que vous avez effectuées n'ont pas été enregistrées."
            />
            <br />
            <FormattedMessage
              id="modal_discard_page_changes"
              defaultMessage="Si vous changez de page, toutes les modifications seront perdues."
            />
            <br />
            <FormattedMessage
              id="modal_discard_question"
              defaultMessage="Souhaitez-vous poursuivre ou revenir en arrière ?"
            />
          </div>
          <div className="discard-changes-buttons">
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={onValidate}
              id="button-form-validation"
            >
              <FormattedMessage
                id="discard_changes_button"
                defaultMessage="Poursuivre et perdre les modifications"
              />
            </Button>
            <Button
              className="btn-standard btn-outline"
              onClick={onClose}
              type="button"
              id="button-form-reset"
            >
              <FormattedMessage
                id="go_back_button"
                defaultMessage="Revenir en arrière"
              />
            </Button>
          </div>
          <br /> <br />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default DiscardChangesModal;
